import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=639e264d&scoped=true&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e264d",
  null
  
)

export default component.exports